import { render, staticRenderFns } from "./AIEducation.vue?vue&type=template&id=2756ab26&scoped=true"
import script from "./AIEducation.vue?vue&type=script&lang=js"
export * from "./AIEducation.vue?vue&type=script&lang=js"
import style0 from "./AIEducation.vue?vue&type=style&index=0&id=2756ab26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2756ab26",
  null
  
)

export default component.exports